export default {
	init() {
    window.renderAsset = function(file, type) {
      document.querySelector('.spinner').style.display = 'block';
      $('#asset-rev').foundation('open');
      setTimeout(() => {
        let postData = type+'&'+file;
        $.ajax({
         type: "POST",
         url: '/wp-content/themes/sage-foundation/resources/render-ajax.php',
         data: { file: file, type: type },
         beforeSend:function(data) {
           document.querySelector('.spinner').style.display = 'block';
         },
         success:function(data) {
          document.querySelector('.spinner').style.display = 'none';
          $('#asset-rev').html(data);
        },
      });
      }, '500');
    }
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js